import { useIsMobile } from "@/hooks/use-media-query";
import { useChatStore } from "@/store/chatStore";
import { ChatList } from "@/components/chat/ChatList";
import { ChatHeader } from "@/components/chat/ChatHeader";
import { ChatMessages } from "@/components/chat/ChatMessages";
import { ChatInput } from "@/components/chat/ChatInput";
import { NetworkStatusBar } from "@/components/ui/network-status";
import { Loader2 } from "lucide-react";
import { Sidebar } from "@/components/Sidebar";
import { useAuth } from "./hooks/use-auth";

function ChatApp() {
  const isMobile = useIsMobile();
  const selectedRoomId = useChatStore((state) => state.selectedRoomId);
  const { isLoading } =   useAuth();

  if (isLoading) {
    return (
      <div className="size-full flex items-center justify-center h-screen bg-background">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  // Mobile view - show either list or chat
  if (isMobile) {
    return (
      <div className="h-screen bg-background flex flex-col w-full">
        {selectedRoomId ? (
          <div className="flex flex-col h-full">
            <ChatHeader />
            <ChatMessages />
            <ChatInput />
          </div>
        ) : (
          <ChatList />
        )}
        <NetworkStatusBar />
      </div>
    );
  }

  // Desktop view - show both
  return (
    <div className="flex h-screen bg-background w-full">
      <Sidebar />
      <div className="w-80 flex-shrink-0 border-r">
        <ChatList />
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        <ChatHeader />
        <ChatMessages />
        {!!selectedRoomId && <ChatInput />}
      </div>
    </div>
  );
}

export default function App() {
  return <ChatApp />;
}
